import { render, staticRenderFns } from "./TimestampComponent.vue?vue&type=template&id=3a25f2a0&"
import script from "./TimestampComponent.vue?vue&type=script&lang=ts&"
export * from "./TimestampComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports